import { render, staticRenderFns } from "./myTemplate.vue?vue&type=template&id=09adfff6&scoped=true&"
import script from "./myTemplate.vue?vue&type=script&lang=js&"
export * from "./myTemplate.vue?vue&type=script&lang=js&"
import style0 from "./myTemplate.vue?vue&type=style&index=0&id=09adfff6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09adfff6",
  null
  
)

export default component.exports